export const OUR_BRANDS_LABEL = "OUR_BRANDS_LABEL";
export const BRANDS_HEADING = "BRANDS_HEADING";
export const BRANDS_HEADING_EMPHASIS = "BRANDS_HEADING_EMPHASIS";
export const BRANDS_SUBTITLE = "BRANDS_SUBTITLE";

export const BRAND_NUKRISHI_KICKER = "BRAND_NUKRISHI_KICKER";
export const BRAND_NUKRISHI_NAME = "BRAND_NUKRISHI_NAME";
export const BRAND_NUKRISHI_DESC = "BRAND_NUKRISHI_DESC";
export const BRAND_NUKRISHI_TAG_1 = "BRAND_NUKRISHI_TAG_1";
export const BRAND_NUKRISHI_TAG_2 = "BRAND_NUKRISHI_TAG_2";
export const BRAND_NUKRISHI_TAG_3 = "BRAND_NUKRISHI_TAG_3";

export const BRAND_AMERICANBULLS_KICKER = "BRAND_AMERICANBULLS_KICKER";
export const BRAND_AMERICANBULLS_NAME = "BRAND_AMERICANBULLS_NAME";
export const BRAND_AMERICANBULLS_DESC = "BRAND_AMERICANBULLS_DESC";
export const BRAND_AMERICANBULLS_TAG_1 = "BRAND_AMERICANBULLS_TAG_1";
export const BRAND_AMERICANBULLS_TAG_2 = "BRAND_AMERICANBULLS_TAG_2";

export const BRAND_VISIT_CTA = "BRAND_VISIT_CTA";
